import { useReactiveVar } from '@apollo/client';
import { soraClientId } from '../../../../API/instance/createInstance';
import { sifeEndpoints } from '../../../../API/sifeEndpoints';
import { VERIFICATION_TOKEN } from '../../IdentityVerificationDialog/IdentityVerificationDialog.constants';
import { useGetMyProfile } from '../../../../containers/RHPod/EmployeePortal/useGetMyProfile';
import {
  videoAgreementIdentityVerificationDialogVar,
  setVideoAgreementIdentityVerificationDialogVar,
  resetVideoAgreementIdentityVerificationDialogVar,
} from '../VideoAgreementIdentityVerificationDialog.vars';
import {
  globalBackdropVar,
  globalSnackbarVar,
} from '../../../../cache.reactiveVars';
import {
  VIDEO_AGREEMENT_TYPES,
  VIDEO_AGREEMENT_VERIFICATION_ERROR_MESSAGES,
  VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES,
} from '../VideoAgreementIdentityVerificationDialog.constants';

export function useAddVideoAgreementToIdentityVerification() {
  const { fetchMyProfile } = useGetMyProfile();
  const { videoRecorded, verificationId, onFinish } = useReactiveVar(
    videoAgreementIdentityVerificationDialogVar,
  );

  const handleAddVideoAgreementToIdentityVerification = async () => {
    if (!videoRecorded || !verificationId) return;
    try {
      globalBackdropVar({
        open: true,
        clickable: false,
        text: 'Verificando video acuerdo...',
      });

      const formData = new FormData();
      formData.append('video', videoRecorded);
      formData.append('verificationId', verificationId);
      formData.append('clientId', soraClientId);
      formData.append(
        'videoAgreementType',
        VIDEO_AGREEMENT_TYPES.IDENTITY_VERIFICATION_VIDEO_AGREEMENT,
      );

      const response = await sifeEndpoints.addVideoAgreement.post(formData);
      globalBackdropVar({ open: false });

      if (response.status === 200) {
        await fetchMyProfile();
        const { completionToken } = response.data.data;
        localStorage.setItem(VERIFICATION_TOKEN, completionToken);
        onFinish();
        resetVideoAgreementIdentityVerificationDialogVar();
        globalSnackbarVar({
          show: true,
          message: 'Videoacuerdo verificado exitosamente',
          severity: 'success',
        });
        return;
      }

      let errMsg = VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES.UNEXPECTED_ERROR;
      if (response.status === 400) {
        const errors = response.data.errors as any[];
        const errorTypes = errors.map((error) => error.type);
        errMsg =
          VIDEO_AGREEMENT_VERIFICATION_ERROR_MESSAGES[errorTypes[0]] ||
          VIDEO_AGREEMENT_VERIFICATION_ERROR_MESSAGES[
            VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES.UNEXPECTED_ERROR
          ];
      }
      setVideoAgreementIdentityVerificationDialogVar({ errorMessage: errMsg });
      globalSnackbarVar({ show: true, message: errMsg, severity: 'error' });
    } catch (error) {
      globalBackdropVar({ open: false });
      globalSnackbarVar({
        show: true,
        message: 'Ocurrió un error al verificar el video acuerdo',
        severity: 'error',
      });
    }
  };

  return { handleAddVideoAgreementToIdentityVerification };
}
